import { useWatch } from 'react-hook-form';

import { generateSlug } from '../utils';

type IUseSlug = {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any;
};

export function useSlug({ control, name }: IUseSlug) {
  const value = useWatch({
    control,
    name,
  });

  return { value: value ? generateSlug(value) : undefined };
}
